<template>
  <div class="productm" >
    <van-sticky>
      <div class="nav">
        <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
        <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
      </div>
      <van-overlay :show="overlayshow" @click="overlayshow = false">
        <div class="wrapper" >
          <div class="nav" v-bind:class="{ 'navActive2': overlayshow }">
            <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
            <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
          </div>
          <div class="navselect" @click="goIndex">
            <van-icon name="arrow" />首页
          </div>
          <div class="navselect" @click="toBg3">
            <van-icon name="arrow" />业务介绍
          </div>
          <div class="navselect" @click="toBg4">
            <van-icon name="arrow" />合作伙伴
          </div>
          <div class="navselect" @click="toBg5" >
            <van-icon name="arrow" />软件著作权
          </div>
          <div class="navselect" @click="toBg6">
            <van-icon name="arrow" />联系我们
          </div>
          <div class="navselect" @click="toRecruitm">
            <van-icon name="arrow" />诚聘英才
          </div>
        </div>
      </van-overlay>
    
      
      <div ref="wrapper" class="wrapper1">
        <ul class="cont" ref="cont">
          <li class="cont-item" v-for="(item,index) of imgs" :key="index" :class="active==index ? 'activeClass' : '  ' " @click="change(index)">
            <div class="cont-img">
              {{item.url}}
            </div>
          </li>
          
        </ul>
      </div>
    </van-sticky>
      <div class="con">

        <div class="con1" v-if="show1"><img src="../assets/mobile/01@2x.png"></div>
        <div class="con2" v-if="show2"><img src="../assets/mobile/02@2x.png"></div>
        <div class="con3" v-if="show3"><img src="../assets/mobile/03@2x.png"></div>
        <div class="con4" v-if="show4"><img src="../assets/mobile/04@2x.png"></div>
        <div class="con5" v-if="show5"><img src="../assets/mobile/05@2x.png"></div>
        <div class="con6" v-if="show6"><img src="../assets/mobile/06@2x.png"></div>
        <div class="con7" v-if="show7"><img src="../assets/mobile/07@2x.png"></div>
        <div class="con8" v-if="show8"><img src="../assets/mobile/08@2x.png"></div>
        <div class="con9" v-if="show9"><img src="../assets/mobile/09@2x.png"></div>
        <div class="con10" v-if="show10"><img src="../assets/mobile/10@2x.png"></div>
      </div> 
      <div class="footer">
        <img src="../assets/mobile/logo@2x.png" >
        <div class="name">上海清裔钲商务咨询有限公司 贵阳清钲金融科技有限公司(c)</div>
        <div class="copyright"  @click="gobeian">2016-{{ currentYear }} All Rights Reserved 黔ICP备17007172号-1</div>
      </div>
      <div style="height:200px"></div>
           
    </div>
</template>
<script>
import BScroll from '@better-scroll/core'
export default {
  name: 'product_m',
  data (){
    return{
      currentYear: new Date().getFullYear(),
      active:'0',
      overlayshow:false,
      activeIndex: '1',
      scrollFlag:false,
      scrollFlag2:false,
      imgs:[
        {url: '内容转接平台', isShow:false},
        {url: '云金融服务平台',isShow:false, },
        {url: '信用卡还款系统',isShow:false, },
        {url: '互联网支付系统',isShow:false, },
        {url: '慧收付系统', isShow:false},
        {url: '银行发卡系统', isShow:false},
        {url: '便民缴费系统', isShow:false},
        {url: '信贷管理系统', isShow:false},
        {url: '银行卡收单系统', isShow:false},
        {url: '聚合支付系统', isShow:false},
      ],
      show1:true,
      show2:false,
      show3:false,
      show4:false,
      show5:false,
      show6:false,
      show7:false,
      show8:false,
      show9:false,
      show10:false,
    }
  },
  methods:{
    change(index){
    this.active=index;
    switch (index) {
      case 0:
        this.show1=true
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 1:
        this.show1=false
        this.show2=true
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 2:
        this.show1=false
        this.show2=false
        this.show3=true
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 3:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=true
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 4:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=true
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 5:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=true
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 6:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=true
        this.show8=false
        this.show9=false
        this.show10=false
        break;
        case 7:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=true
        this.show9=false
        this.show10=false
        break;
        case 8:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=true
        this.show10=false
        break;
        case 9:
        this.show1=false
        this.show2=false
        this.show3=false
        this.show4=false
        this.show5=false
        this.show6=false
        this.show7=false
        this.show8=false
        this.show9=false
        this.show10=true
        break;
    
      default:
        break;
    }
   },
   gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      toRecruitm(){
        
        this.$router.push('/recruit_m')
        
      },
      goIndex(){
        sessionStorage.setItem('nav','index')
        this.$router.push('/')
      },
    toBg3(){
         sessionStorage.setItem('nav','Bg3')
         this.$router.push('/')
      },
      toBg4(){
        sessionStorage.setItem('nav','Bg4')
         this.$router.push('/')
      },
      toBg5(){
        sessionStorage.setItem('nav','Bg5')
         this.$router.push('/')
      },
      toBg6(){
        sessionStorage.setItem('nav','Bg6')
         this.$router.push('/')
      },

    verScroll () {
      let width = this.imgs.length * 90 +250// 动态计算出滚动区域的大小，前面已经说过了，产生滚动的原因是滚动区域宽度大于父盒子宽度
      this.$refs.cont.style.width = width + 'px'  // 修改滚动区域的宽度
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.wrapper, {
            startX: 500,
            startY: 0,  // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: 'vertical'
          })
         
          
        } else {
          this.scroll.refresh() //如果dom结构发生改变调用该方法
        }
      })
    },
  },
  mounted(){
    this.$nextTick(() => {
            let timer = setTimeout(() => { 
              if (timer) {
                clearTimeout(timer)
                this.verScroll()
              }
            }, 0)
          })
  }
}


</script>
<style scoped>
.productm {
  width: 100%;

}
.productm .activeClass{
  width: 90px;
  height: 24px;
  background: #0B1525;
border-radius: 12px;
border-radius: 12px;
color: #fff;
}
.productm .wrapper1{
width: 100%;
overflow: hidden;
background: #F7F7F7;
height: 40px;
line-height: 40px;
}
.productm .wrapper1 .cont{
list-style: none;
white-space: nowrap;
text-align: center;
}
.productm .wrapper1 .cont .cont-item{
position: relative;
display: inline-block;
margin-right: 20px;
width: 90px;
text-align: center;
font-family: PingFangSC-Regular;
font-size: 11px;
color: #333333;
margin-top: 8px;
line-height: 24px;
}
.productm .activeClass .cont-img{
  color: #fff;
}
.productm .wrapper1 .cont .cont-item .cont-img{
   overflow: hidden;
}
.productm .wrapper1 .cont .cont-item .cont-img img{
  width: 100%;
}
.productm .nav{
  width: 100%;
  background-color: #0B1525 ;
  height: 40px;
}
.productm .nav .left{
  position: absolute;
  left: 0;
}
.productm .nav .left img{
  width: 100px;
  height: 30px;
  margin-left: 10px;
  margin-top: 5px;
}
.productm .nav .right{
  float: right;
}
.productm .nav .right img{
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 10px;
}
.productm .navActive2{
  background-color: #0B1525 ;
}
.productm .navselect{
  width: 100%;
  height: 60px;
  background: #0B1525;
  line-height: 60px;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #FFFFFF;
text-align: left;
}
.productm .navselect .van-icon-arrow{
color: #DBBA66;
margin-left: 14px;
margin-right: 6px;
}
.productm .con{
  width: 375px;
  margin: 0 auto;
  margin-top: fixed;
}
.productm .con1 img{
width: 375px;
max-width: 100%;
height: 1559px;
margin: 0 auto;
}
.productm .con2 img{
  width: 375px;
  height: 610px;
max-width: 100%;
margin: 0 auto;
}
.productm .con3 img{
  width: 375px;
  height: 500px;
max-width: 100%;
margin: 0 auto;
}
.productm .con4 img{
  width: 375px;
  height: 540px;
max-width: 100%;
margin: 0 auto;
}
.productm .con5{
  
}
.productm .con5 img{
  width: 375px;
  height: 348px;
max-width: 100%;
margin: 0 auto;
}
.productm .con6 img{
  width: 375px;
  height: 935px;
max-width: 100%;
margin: 0 auto;
}
.productm .con7 img{
  width: 375px;
  height: 804px;
max-width: 100%;
margin: 0 auto;
}
.productm .con8 img{
  width: 375px;
  height: 1175px;
max-width: 100%;
margin: 0 auto;
}
.productm .con9 img{
  width: 375px;
  height: 600px;
max-width: 100%;
margin: 0 auto;
}

.productm .con10 img{
  width: 375px;
  height: 510px;
max-width: 100%;
margin: 0 auto;
}
.productm .footer{
     width: 100%;
  height: 130px;
  background-image: url("../assets/mobile/footer@2x.png");
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  bottom: 0;
}
.productm .footer img{
width: 100px;
height: 30px;
margin:0 auto;
margin-top: 20px;
}
.productm .footer .name{
  font-family: PingFangSC-Semibold;
  font-weight: 600;
font-size: 7px;
color: #FFFFFF;
text-align: center;
margin-top: 15px;
}
.productm .footer .copyright{
  font-family: PingFangSC-Semibold;
font-size: 7px;
color: #848991;
text-align: center;
margin-top: 3px;
}

</style>